import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserVerifyComponent} from './user-verify.component';
import {TranslateModule} from '@xref/ngx';
import {HeaderModule} from "../header/header.module";
import {FooterModule} from "../footer/footer.module";
import {ButtonModule, InputsModule} from "@xref/xref-lib";
import {FormsModule} from "@angular/forms";
import {OmniLoaderModule} from "../omni-loader/omni-loader.module";

@NgModule({
    declarations: [UserVerifyComponent],
    imports: [
        CommonModule,
        TranslateModule,
        HeaderModule, FooterModule,
        InputsModule,
        FormsModule,
        ButtonModule,
        OmniLoaderModule
    ],
    exports: [UserVerifyComponent]
})
export class UserVerifyModule {
}
